import { Fragment} from 'react';
import Typography from '@mui/material/Typography';
import { Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const Employment: React.FC = ()=>{
  
  // calculate duration
  const getDuration = (startDate: string, endDate: string) => {
    const parseDate  = (date: string) => {
      if (date.toLowerCase() === 'present') return new Date();
      const [month, year] = date.split('/');
      return new Date(parseInt(year), parseInt(month) - 1);
    }
    const start = parseDate(startDate);
    const end = parseDate(endDate);
    
    const diff = Math.abs(end.getTime() - start.getTime());
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    const remainingMonths = months % 12; // remaining months
    
    if (years > 0 && remainingMonths > 0) {
    return `${years} years and ${remainingMonths} months`;
  } else if (years > 0) {
    return `${years} years`;
  } else if (remainingMonths > 0) {
    return `${remainingMonths} months`;
  } else {
    return '';
  }
  }

  interface EmploymentDetails {
    title: string,
    company: string,
    startDate: string,
    endDate: string,
    duration?: string,
    description: string,
    achievement: string
  }
  const employmentDetails : EmploymentDetails [] = [
    {
      title: 'Software Developer',
      company: 'CodeCabin',
      startDate: '05/2024',
      endDate: '07/2025',
      duration: getDuration('05/2024', '07/2025'),
      description: 'Design and develop custom software tailored to client\'s needs.\nUse of tech stack ReactJS, Redux Toolkit, Bootstrap, REST API.\nFeatures planning, tracking and development with Trello and Git.\nParticipate in development and liaise with clients across multiple projects',
      achievement:'Successfully implemented multiple features, analysed complex requirements and gained client satisfaction',
    },
    {
      title: 'Frontend Developer',
      company: 'PTC',
      startDate: '12/2023',
      endDate: '05/2024',
      duration: getDuration('12/2023', '05/2024'),
      description: 'Design and develop front end features.\nDevelop Mapping software with stack: React TS, React Flow and Redux Toolkit.\nKnowledge of JSON and JSON Schema.\nTasks/issues tracking on Github Projects and Git.\nWrite Vitest to ensure robust functionalities',
      achievement:'Implemented & improved front-end UI for the overall software',
    },
    {
      title: 'E-Commerce & Marketing Officer',
      company: 'Cloer Asia Pacific',
      startDate: '02/2021',
      endDate: '02/2022',
      duration: getDuration('02/2021', '02/2022'),
      description: 'Manage SEO & Google Ads campaigns base on KPI. \nManage E-commerce activities on Shopify platform.\nPlan & Design e-commerce website.\nManage web contents include product product images and videos',
      achievement:'Increased monthly e-commerce sales activities and overall SEO performance',
    },
    {
      title: 'Marketing Executive',
      company: 'Telford International',
      startDate: '02/2020',
      endDate: '12/2020',
      duration: getDuration('02/2020', '12/2020'),
      description: 'Manage on-going SEO & Google Ads campaigns. \nBrand Management, Market Research & Customer Acquisition',
      achievement:'Successfully initiated SEO and Google Ads campaigns and achieved Customer Retention & Acquisition KPI.Successfully initiated SEO and Google Ads campaigns and achieved Customer Rentention & Acquisition KPI.'
    },
    {
      title: 'Sales & Marketing Executive',
      company: 'AmeriCraft Imports',
      startDate: '05/2014',
      endDate: '10/2017',
      duration: getDuration('05/2014', '10/2017'),
      description: 'Sales & Marketing Activities in Hong Kong Market for 10 different craft beer brands.',
      achievement: 'Achieved quarterly Client Acquisition KPI through Sales & Marketing activitiesAchieved quarterly Client Acquisition KPI through Sales & Marketing activities'
    }
  ]


  return (
    <>
    <List id='employment' sx={{width: '100%', borderColor:'white', columnGap:2}}>
      <Typography variant='h4' sx={{mb:1}}>
        EXPERIENCE
      </Typography>
      {employmentDetails.map((employment, index) => (
        <Fragment key={index}>
          <ListItem alignItems='flex-start' sx={{lineHeight:'1.5', columnGap:2}}>
            <ListItemIcon>
              <WorkIcon fontSize='large'/>
            </ListItemIcon>
            <ListItemText
              sx={{wordSpacing:2}}
              primary={<Fragment>
                <Typography
                  sx={{display:'inline'}}
                  component="span"
                  variant='h5'
                  color='text.primary'
                  >
                  {employment.title}
                </Typography>
              </Fragment>}
              secondary={
                <Fragment>
                  <Typography
                    sx={{display: 'inline'}}
                    component='span'
                    variant='body1'
                    color='text.primary'>
                      {employment.company}
                    </Typography>
                    <br/>
                  <Typography
                    sx={{display: 'grid', paddingTop:"1rem", paddingBottom:"1rem"}}
                    component='span'
                    variant='body1'
                    color='text.secondary'
                  >
                    {employment.startDate} - {employment.endDate}{employment.duration && ` (${employment.duration})`}
                  </Typography>
                    <div>
                      {/* break line with \n */}
                      {employment.description.split('\n').map((line, index) => (
                        <Fragment key={index}>
                          <Typography
                            sx={{display: 'inline', columnGap:2}}
                            component='span'
                            variant='body2'
                            color='text.primary'>
                              <FiberManualRecordIcon fontSize="small" sx={{marginRight:1}}/>{line}
                          </Typography>
                          <br/>
                        </Fragment>
                      ))}
                    </div>
                    <Typography
                      sx={{display: 'grid', paddingTop:"1rem", paddingBottom:"1rem"}}
                      component='span'
                      variant='body1'
                      color='text.secondary'
                    >
                    Achievement: {employment?.achievement}
                  </Typography>
                </Fragment>
              }  
            >
            </ListItemText>
          </ListItem>
          <Divider/>
        </Fragment>
      ))}
    </List>
    </>
  )
}